import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { string, ref } from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
// import { SelectEmployee } from "../Include/DynamicSelect";
import { UPDATE_INCOME_HEADS } from "../../Schema/IncomeHead";

export default function UpdateIncomeHead({
  open,
  handleClose,
  setRefetch,
  editData,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [updateIncomeHead] = useMutation(UPDATE_INCOME_HEADS, {
    onCompleted: ({ updateIncomeHead }) => {
      setLoading(false);
      if (updateIncomeHead?.status === true) {
        setAlert(true, "success", updateIncomeHead?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateIncomeHead?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const Validate = Yup.object().shape({
    incomeType: Yup.string().required("require!"),
    price: Yup.number()
      .min(0, "price must be more than 0!")
      .required("require!"),
    incomeHead: Yup.string().required("require!"),
    unit: Yup.string().required("require!"),
    note: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      incomeType: "",
      price: 0,
      incomeHead: "",
      unit: "",
      note: "",
    },

    validationSchema: Validate,
    onSubmit: async (values) => {
      //   console.log("values:::", values);
      setLoading(true);

      updateIncomeHead({
        variables: {
          id: editData?._id,
          ...values,
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("incomeType", editData?.incomeType);
      setFieldValue("price", editData?.price);
      setFieldValue("incomeHead", editData?.incomeHead);
      setFieldValue("unit", editData?.unit);
      setFieldValue("note", editData?.note);
    }
  }, [editData]);
  //   console.log("editData", editData);
  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Update income head</Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">Income type</Typography>
                <FormControl className="text-field" fullWidth size="small">
                  <Select
                    value={values?.incomeType}
                    onChange={(e) =>
                      setFieldValue("incomeType", e?.target?.value)
                    }
                  >
                    <MenuItem value="AdminFee">AdminFee</MenuItem>
                    <MenuItem value="Trail One Month">Trail One Month</MenuItem>
                    <MenuItem value="Meal Service">Meal Service</MenuItem>
                    <MenuItem value="Transportation Service">
                      Transportation Service
                    </MenuItem>
                    <MenuItem value="School Uniform">School Uniform</MenuItem>
                    <MenuItem value="Material">Material</MenuItem>
                    <MenuItem value="Rental">Rental</MenuItem>
                    <MenuItem value="Electricity">Electricity</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">Income head</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder="income head"
                  {...getFieldProps("incomeHead")}
                  error={Boolean(touched.incomeHead && errors.incomeHead)}
                  helperText={touched.incomeHead && errors.incomeHead}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className="field-title">Price</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder="price"
                  type="number"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ mr: 1 }}>
                        $
                      </InputAdornment>
                    ),
                    inputProps: {
                      min: 0,
                    },
                  }}
                  {...getFieldProps("price")}
                  error={Boolean(touched.price && errors.price)}
                  helperText={touched.price && errors.price}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className="field-title">Unit</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder="unit"
                  {...getFieldProps("unit")}
                  error={Boolean(touched.unit && errors.unit)}
                  helperText={touched.unit && errors.unit}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">Note</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  type="text"
                  placeholder="note"
                  {...getFieldProps("note")}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("update")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
